import { TextField, type SxProps, type Theme } from '@mui/material'
import type React from 'react'
import { defaultSx } from './SurveyTextField.styles'

interface SurveyTextFieldProps {
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  placeholder?: string
  rows?: number
  height?: string | number
  multiline?: boolean
  disabled?: boolean
  dataTestId?: string
  sx?: SxProps<Theme>
}

export const SurveyTextField: React.FC<SurveyTextFieldProps> = ({
  value,
  onChange,
  placeholder,
  dataTestId,
  height,
  multiline = true,
  disabled = false,
  rows = 3,
  sx
}) => {
  return (
    <TextField
      multiline={multiline}
      variant="filled"
      disabled={disabled}
      value={value}
      onChange={onChange}
      placeholder={placeholder ?? 'Add details here'}
      rows={multiline ? rows : undefined}
      data-testid={dataTestId}
      sx={{
        ...defaultSx,
        ...(multiline && height != null && { height }),
        ...sx
      }}
    />
  )
}
